import {
  FETCH_TOTAL_PROVISION_QUALITY_SUCCESS,
  FETCH_CONNECTIONS_QUALITY_SUCCESS,
  FETCH_BUSINESSES_QUALITY_SUCCESS,
  FETCH_TOTAL_PROVISION_QUALITY,
  FETCH_CONNECTIONS_QUALITY,
  FETCH_BUSINESSES_QUALITY,
  FETCH_USEFUL_STATS,
  FETCH_USEFUL_STATS_SUCCESS,
  FETCH_USEFUL_STATS_FAILURE,
  FETCH_BUSINESSES_QUALITY_FAILURE,
  FETCH_CONNECTIONS_QUALITY_FAILURE,
  FETCH_TOTAL_PROVISION_QUALITY_FAILURE,

  FETCH_BUSINESS_CODES,
  FETCH_BUSINESS_CODES_SUCCESS,
  FETCH_BUSINESS_CODES_FAILURE,
  FETCH_SINGLE_PROVISION_QUALITY,
  FETCH_SINGLE_PROVISION_QUALITY_SUCCESS,
  FETCH_SINGLE_PROVISION_QUALITY_FAILURE,
  SELECT_RESOURCE_TYPE,
  SELECT_BUSINESS_CODE,
  FETCH_CONNECTION_MONITOR_DATA,
  FETCH_NOTIFICATIONS_PANEL_DATA,
  FETCH_CONNECTION_MONITOR_DATA_SUCCESS,
  FETCH_CONNECTION_MONITOR_DATA_FAILURE,
  FETCH_HEARTBEAT_MONITOR_STATUS,
  FETCH_HEARTBEAT_MONITOR_STATUS_SUCCESS,
  FETCH_HEARTBEAT_MONITOR_STATUS_FAILURE,
  FETCH_COMMUNICATIONS_SUCCESS,
} from './types';

import {
  fetchTotalQuality as fetchTotalQualityApi,
  fetchConnectionsQuality as fetchConnectionsQualityApi,
  fetchBusinessesQuality as fetchBusinessesQualityApi,
  fetchUsefulStats as fetchUsefulStatsApi,
  fetchConnectionMonitorData as fetchConnectionMonitorDataApi,
  fetchHeartbeatMonitorStatus as fetchHeartbeatMonitorStatusApi,
  fetchNotificationsPanelData as fetchNotificationsPanelDataApi,
  fetchConnectionQuality as fetchConnectionQualityApi,
  fetchBusinessQuality as fetchBusinessQualityApi,
  fetchCommunications as fetchCommunicationsApi,
} from '../api';
import { fetchConnections, fetchingError, selectPeriod, selectConnection, fetchProvisions } from '../../shared/store/actions';
import { resourceTypes } from '../provisionQualitySinglePage/provisionQualitySingle.constants';
import { errorNotification } from '../../shared/store/notificationActions';

import { byField } from '../../utils/sorting';
import Routes from '../../routes';

export const fetchTotalProvisionQuality = () => async (dispatch, getState) => {
  dispatch({
    type: FETCH_TOTAL_PROVISION_QUALITY,
  });

  const { period, currentPeriod } = getState().shared;
  const periodName = period.name || currentPeriod.name;

  try {
    const responseData = await fetchTotalQualityApi({
      periodName,
    });

    return dispatch({
      type: FETCH_TOTAL_PROVISION_QUALITY_SUCCESS,
      totalProvisionQuality: responseData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_TOTAL_PROVISION_QUALITY_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const fetchConnectionsQuality = () => async (dispatch, getState) => {
  dispatch({
    type: FETCH_CONNECTIONS_QUALITY,
  });

  const { period, currentPeriod } = getState().shared;
  const periodName = period.name || currentPeriod.name;

  try {
    const responseData = await fetchConnectionsQualityApi({ periodName });

    return dispatch({
      type: FETCH_CONNECTIONS_QUALITY_SUCCESS,
      connectionsQuality: responseData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_CONNECTIONS_QUALITY_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const fetchBusinessesQuality = () => async (dispatch, getState) => {
  dispatch({
    type: FETCH_BUSINESSES_QUALITY,
  });

  const { period, currentPeriod } = getState().shared;
  const periodName = period.name || currentPeriod.name;

  try {
    const responseData = await fetchBusinessesQualityApi({
      periodName,
    });

    return dispatch({
      type: FETCH_BUSINESSES_QUALITY_SUCCESS,
      businessesQuality: responseData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_BUSINESSES_QUALITY_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const fetchUsefulStats = () => async (dispatch, getState) => {
  dispatch({
    type: FETCH_USEFUL_STATS,
  });

  const { period, currentPeriod } = getState().shared;
  const periodName = period.name || currentPeriod.name;

  try {
    const responseData = await fetchUsefulStatsApi({ periodName });

    return dispatch({
      type: FETCH_USEFUL_STATS_SUCCESS,
      usefulStats: responseData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_USEFUL_STATS_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForQualityOverviewPage = () => dispatch => {
  dispatch(fetchTotalProvisionQuality());
  dispatch(fetchConnectionsQuality());
  dispatch(fetchBusinessesQuality());
  return dispatch(fetchUsefulStats());
};

export const selectPeriodForQualityOverviewPage = period => async dispatch => {
  await dispatch(selectPeriod(period));

  return Promise.all([
    dispatch(fetchTotalProvisionQuality()),
    dispatch(fetchConnectionsQuality()),
    dispatch(fetchBusinessesQuality()),
    dispatch(fetchUsefulStats()),
  ]);
};

export const fetchConnectionMonitorData = period => async dispatch => {
  dispatch({
    type: FETCH_CONNECTION_MONITOR_DATA,
  });

  try {
    const responseData = await fetchConnectionMonitorDataApi(period.name);

    return dispatch({
      type: FETCH_CONNECTION_MONITOR_DATA_SUCCESS,
      connectionsMonitorData: responseData.connectionsMonitorData,
      connectionsMonitorUpdateTime: Date.now(),
      overallStatus: responseData.overallStatus,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CONNECTION_MONITOR_DATA_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchHeartbeatMonitorStatus = () => async dispatch => {
  dispatch({
    type: FETCH_HEARTBEAT_MONITOR_STATUS,
  });

  try {
    const responseData = await fetchHeartbeatMonitorStatusApi();

    return dispatch({
      type: FETCH_HEARTBEAT_MONITOR_STATUS_SUCCESS,
      heartbeatMonitorStatus: responseData,
    });
  } catch (error) {
    dispatch({
      type: FETCH_HEARTBEAT_MONITOR_STATUS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchBusinessCodes = period => async dispatch => {
  dispatch({
    type: FETCH_BUSINESS_CODES,
  });

  try {
    const responseData = await fetchBusinessesQualityApi({
      periodName: period.name,
    });

    return dispatch({
      type: FETCH_BUSINESS_CODES_SUCCESS,
      businessCodes: responseData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_BUSINESS_CODES_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const fetchProvisionQualityForSingle = (period, value, resourceType) => async dispatch => {
  dispatch({
    type: FETCH_SINGLE_PROVISION_QUALITY,
  });

  try {
    const params = resourceType === resourceTypes.connection
      ? {
        periodName: period.name,
        connectionName: value,
      }
      : {
        periodName: period.name,
        businessCode: value,
      };

    const result = resourceType === resourceTypes.connection
      ? await fetchConnectionQualityApi(params)
      : await fetchBusinessQualityApi(params);

    return dispatch({
      type: FETCH_SINGLE_PROVISION_QUALITY_SUCCESS,
      result,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_SINGLE_PROVISION_QUALITY_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const selectPeriodForSingle = period => async dispatch => {
  dispatch(selectPeriod(period));

  dispatch(fetchConnections(period, {
    includeAllOption: false,
  }));
  dispatch(fetchBusinessCodes(period, false));
};

export const selectResourceTypeForSingle = resourceType => async dispatch => {
  dispatch({
    type: SELECT_RESOURCE_TYPE,
    resourceType,
  });
};

export const selectBusinessCodeForSingle = value => (dispatch, getState) => {
  const businessCodes = getState().dashboard.provisionQualitySingle.businessCodes;
  const businessCode = businessCodes.find(({ businessCode }) => businessCode === value);

  const action = {
    type: SELECT_BUSINESS_CODE,
    businessCode,
  };

  return dispatch(action);
};

export const selectResourceForSingle = (value, resourceType) => async dispatch => {
  if (resourceType === resourceTypes.connection) {
    dispatch(selectConnection(value));
  }

  if (resourceType === resourceTypes.business) {
    dispatch(selectBusinessCodeForSingle(value));
  }
};

const additionalNotificationsData = {
  diagnostics: {
    key: 'diagnostics',
    description: '',
    url: Routes.balanceSheetManagement.notificationsSubRoutes.DIAGNOSTICS,
  },
  unpostedGL: {
    key: 'unpostedGL',
    description: 'View GL Journals not yet posted to the ERP.',
    url: Routes.balanceSheetManagement.notificationsSubRoutes.UNPOSTED_GL_JOURNALS,
  },
  declined: {
    key: 'declined',
    description: 'View tax entries you entered that were declined.',
    url: Routes.balanceSheetManagement.notificationsSubRoutes.DECLINED_TAX_ENTRIES,
  },
  approvals: {
    key: 'approvals',
    description: 'View tax entries that are ready for your review.',
    url: Routes.balanceSheetManagement.APPROVE_TAX_ENTRIES,
  },
  pendingApproval: {
    key: 'pendingApproval',
    description: 'View tax entries you entered that are awaiting review.',
    url: Routes.balanceSheetManagement.notificationsSubRoutes.TAX_ENTRIES_PENDING_APPROVAL,
  },
};

export const fetchNotificationsPanelData = () => async (dispatch, getState) => {
  const { period, currentPeriod } = getState().shared;

  const periodName = period.name || currentPeriod.name;

  try {
    const responseData = await fetchNotificationsPanelDataApi(periodName);

    const notifications = Object.keys(responseData)
      .map(type => ({
        ...responseData[type],
        ...additionalNotificationsData[type],
      }))
      .sort(byField('sortOrder'));

    return dispatch({
      type: FETCH_NOTIFICATIONS_PANEL_DATA,
      notifications,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForSinglePage = ({ period, resource, resourceType, params }) =>
  async dispatch => {
    await dispatch(fetchConnections(period, {
      includeAllOption: false,
      setConnection: false,
    }));
    await dispatch(fetchBusinessCodes(period));

    if (params.resource && params.resourceType) {
      await dispatch(selectResourceForSingle(params.resource, params.resourceType));
      dispatch(fetchProvisionQualityForSingle(period, params.resource, params.resourceType));
    } else if (resourceType && resource && resource.value) {
      dispatch(fetchProvisionQualityForSingle(period, resource.value, resourceType));
    }
  };

export const preselectTypeAndResource = (value, resourceType) => async dispatch => {
  dispatch({
    type: SELECT_RESOURCE_TYPE,
    resourceType,
  });

  if (resourceType === resourceTypes.connection) {
    dispatch(selectConnection(value, true));
  }

  dispatch({
    type: SELECT_BUSINESS_CODE,
    businessCode: {
      businessCode: value,
      businessDescription: value,
    },
  });
};

export const fetchCommunications = () => async dispatch => {
  try {
    const communications = await fetchCommunicationsApi();

    return dispatch({
      type: FETCH_COMMUNICATIONS_SUCCESS,
      communications,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectPeriodForDashboard = period => async dispatch => {
  dispatch(selectPeriod(period));
  dispatch(fetchNotificationsPanelData());
  dispatch(fetchConnectionMonitorData(period));
  dispatch(fetchTotalProvisionQuality());
  dispatch(fetchBusinessesQuality());
  dispatch(fetchProvisions(period));
};
